import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class TwiggsMFSeries extends Component {
  static yExtents(datum, index, allData, indicator) {
    const dataArr = Array.isArray(allData)
      ? allData
      : Array.isArray(datum)
        ? datum
        : [datum];

    if (!indicator || !indicator.renderKey) {
      return undefined;
    }

    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;

    dataArr.forEach((item) => {
      const value = item && item[indicator.renderKey];
      if (Number.isFinite(value)) {
        if (value < min) min = value;
        if (value > max) max = value;
      }
    });

    // If no valid data, return undefined
    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      return undefined;
    }

    // Always include zero in the range
    min = Math.min(min, 0);
    max = Math.max(max, 0);

    // Add 10% padding
    const range = max - min;
    const padding = range * 0.1;

    return [min - padding, max + padding];
  }

  render() {
    const { yAccessor, stroke, strokeZeroLine, className, ...rest } =
      this.props;

    return (
      <g className={className}>
        <LineSeries {...rest} yAccessor={yAccessor} stroke={stroke} />
        <StraightLine yValue={0} stroke={strokeZeroLine} />
      </g>
    );
  }
}

TwiggsMFSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.object.isRequired,
  strokeZeroLine: PropTypes.object,
  className: PropTypes.string,
  clip: PropTypes.bool,
  onContextMenu: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

TwiggsMFSeries.defaultProps = {
  strokeZeroLine: { color: "#8795A1", dash: "Solid", width: 1, opacity: 0.5 },
  className: "react-stockcharts-twiggsmf",
  clip: true,
};

export default TwiggsMFSeries;
